import { enterpriseApiSlice } from "./index";
import { BillingDetailsMap, LastMonthBilling, MonthlyBilling } from "../Model/Api/BillingObjects";

export const billingApi = enterpriseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchBillingDetails: builder.query({
      query: () => ({
        url: "/company/billing",
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: ["Billing"],
      transformResponse: (response) => new BillingDetailsMap(response),
    }),
    fetchMonthlyBillings: builder.query({
      query: () => ({
        url: "/monthly-billings",
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: ["MonthlyBilling"],
      transformResponse: (response) => Array.isArray(response)
        ? response.map((billing) => new MonthlyBilling(billing))
        : [],
    }),
    fetchLastMonthBilling: builder.query({
      query: () => ({
        url: "/monthly-billings/last-month",
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: ["MonthlyBilling"],
      transformResponse: (response) => new LastMonthBilling(response),
    }),
    clearLastMonthBilling: builder.mutation({
      query: () => ({
        url: "/monthly-billings/last-month/clear",
        method: "POST",
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["MonthlyBilling", "Charges"],
      transformResponse: (response) => new LastMonthBilling(response),
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchBillingDetailsQuery,
  useFetchMonthlyBillingsQuery,
  useFetchLastMonthBillingQuery,
  useClearLastMonthBillingMutation,
} = billingApi;
